import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IProfessionalType from '../../interfaces/IProfessionalType';
import IProfessional from '../../interfaces/IProfessional';

const useProfessionalService = () => {
  const requestTypes = useRequest<IProfessionalType>();
  const requestProfessional = useRequest<IProfessional>();
  const path = 'professional';

  const listTypes = async (): Promise<IProfessionalType[]> => {
    return await requestTypes
      .getManyPaginated({
        path: `${path}/type?perPage=300&currentPage=1&orderBy=name&orderDirection=asc`,
        sendAuthorization: true,
      })
      .then(result => {
        return result?.data;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listByRegisterEmState = async (register: string, state: string): Promise<IProfessional> => {
    return await requestProfessional
      .getOne({
        path: `${path}/register-number?state=${state}&registerNumber=${register
          .replace('.', '')
          .replace(',', '')
          .replace('/', '')
          .replace(' ', '')
          .replace(';', '')
          .replace('+', '')}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  return { listTypes, listByRegisterEmState };
};

export { useProfessionalService };
